import React, { useCallback, forwardRef } from 'react'

import PropTypes from 'prop-types'

import MuiCheckbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const Checkbox = forwardRef((props, ref) => {
  const {
    id,
    className,
    label,
    onChange,
    checked,
    value,
    size,
    onClick,
    disabled,
    helperText,
    ...otherProps
  } = props

  const handleChange = useCallback((event) => {
    if (!disabled) {
      onChange(event)
    }
  }, [disabled, onChange])

  return (
    <FormControlLabel
      className={ className }
      id={ id }
      onClick={ onClick }
      label={ label }
      { ...otherProps }
      control={ (
        <MuiCheckbox
          ref={ ref }
          value={ value }
          size={ size }
          id={ `${ id }-checkbox-input` }
          disabled={ disabled }
          onChange={ handleChange }
          checked={ !!checked }
          color="primary"
          indeterminate={ checked === null }
        />
      ) }
    />
  )
})

Checkbox.propTypes = {
  /** Identificador do Checkbox */
  id: PropTypes.string.isRequired,
  /** Classe para estilos */
  className: PropTypes.string,
  helperText: PropTypes.string,
  /** Texto que aparece ao lado do Checkbox */
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.element
  ]),
  /** Valor que o Checkbox representa */
  value: PropTypes.any,
  /** Estado do CheckBox (ativo, inativo, indeterminado)  */
  checked: PropTypes.oneOf([true, false, null]),
  /** Função no clique do mouse */
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium'])
}

Checkbox.defaultProps = {
  className: '',
  value: '',
  helperText: '',
  onChange: () => {},
  onClick: () => {},
  disabled: false,
  label: null,
  size: 'small',
  checked: false
}

export default Checkbox
